import { createStore, compose, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from 'src/reducers';

function configureStore(preloadedState = {}) {
    const store = createStore(rootReducer, preloadedState, compose(applyMiddleware(thunkMiddleware)));
    return store;
}

const store = configureStore();
export default store;